<!--新闻·活动-->
<template>
    <div class="sec mt20 content" id="newsActivity">
        <div class="tab-head myflex-v">
            <div class="tab-item tabTitle myflex-v">
                <i class="el-icon-pie-chart title-icon myhide"></i><img src="@/assets/img/icon6.png" class="title-icon-img" /><span>新闻·活动</span>
            </div>
            <div class="sec-right-up myflex-v marginauto-l">
                <div class="look-more" @click="toList">查看更多<i class="el-icon-arrow-right"></i></div>
            </div>
        </div>
        <div v-loading="loading">
            <div class="box mt10" v-if="courseList && courseList.length>0">
                <div class="list-item w-100 myflex-v" v-for="(cItem1,cIndex1) in courseList" :key="cIndex1" @click="toDetail(cItem1.type,cItem1.id)">
                    <i class="dot"></i>
                    <div class="list-text marginauto-l flex1 myflex-v">
                        <span v-if="cItem1.type==1" class="list-label isActivity">活动</span>
                        <span v-else class="list-label">新闻</span>
                        <div class="ellipsis1 flex1 list-course">{{cItem1.title}}</div>
                        <span class="time-box">{{art.formatDate(cItem1.createTime,2)}}</span>
                        <i class="el-icon-arrow-right list-icon"></i>
                    </div>
                </div>
            </div>
            <div v-else class="nodata pad15">暂无数据~</div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .courseNotice{height:220px;}
    .dot{width:5px;height:5px;background:$theme-color;margin:0 10px 0 20px;}
    .time-box{margin-left:15px;font-size:12px;color:#5e686f;}
    .list-item{cursor:pointer;}
    .list-item:last-child .list-text{border-bottom:none;}
    .list-text{border-bottom:1px dashed #ddd;padding:10px 0px 10px 0;margin-right:15px;}
    .list-course{}
    .list-label{font-size:12px;background:$theme-color;padding:1px 2px;color:#fff; margin-right:5px;}
    .list-label.isActivity{background:#ec6941;}
    .list-icon{margin-left:10px;border-radius:50%;padding:1px;font-size:12px;background:rgba(0,0,0,.3);color:#fff;}
    .box{min-height:100px;padding-bottom:10px;}
    .nodata{height:250px;}
</style>

<script>
import CourseListItem from '@/components/CourseListItem.vue';
export default {
    name: "newsActivity",
    components: {
        CourseListItem,
    },
    data(){
        return {
            art: art,
            courseList:[],
            loading: true,
        }
    },
    methods: {

        //获取列表
        getList(type){
            var data = {
                type:type,
                pageNum:1,
                pageSize:6,
                channel: 1,
            }
            this.$api.web.websitContentGetNewsActivityList(data).then(res=>{
                this.courseList = res.body.newsActivityList;
                this.loading = false;
            }).catch(res=>{
                this.loading = false;
            })
        },
        
        //跳到详情页面
        toDetail(type,id){
            const newurl = this.$router.resolve({path: '/newsActivityDetail', query: {id: id}})
            window.open(newurl.href,'_blank');
        },

        //跳到活动列表页面
        toList(){
            const newurl = this.$router.resolve({path: '/newsActivityList', query: {}})
            window.open(newurl.href,'_blank');
        },
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
           this.getList(); 
        }, 500);
    },

}
</script>